import { GlobalActions, GlobalPut, KdvMetadaten } from '@ps20-frontend/shop-integration-redux';
import { call, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../toolbarState';

export function* watchKDVMetadaten() {
  yield takeEvery(GlobalActions.VERMERK_INIT, safeSaga(kdvMetadatenSaga, App.SHOP_TOOLBAR));
}

export function* kdvMetadatenSaga() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const kdvMetadatenPayload: KdvMetadaten = {
    vermerk: state.speichern.vermerk,
    gesamtbeitrag: state.gesamtpreis,
  };
  yield call(globalPut.put, new GlobalActions().kdvMetadatenInit(kdvMetadatenPayload));
}
